module.exports = __webpack_public_path__ + "static/media/250531_10150194794110686_4604629_n.80e85134.jpg";